<template>
  <div class="my-3">
    <h2 id="candidates" v-if="nominated_period">{{ $t('nominated-candidates') }}</h2>
    <h2 id="candidates" v-else>{{ $t('registered-candidates') }}</h2>
    <h3><a :href="mayor_url" target="_blank">{{ $t('mayoral-candidates') }}</a></h3>
    <div class="jump-list">
      <ul class="list-unstyled">
        <li v-for="(mayor, index) in mayors" :key="index">{{ mayor.name }}</li>
      </ul>
    </div>
    
    <h3><a :href="councillor_url" target="_blank">{{ $t('councillor-candidates-for', { ward: addressDetails.councilWard }) }}</a></h3>
    <div class="jump-list">
      <ul class="list-unstyled">
        <li v-for="(councillor, index) in councillors" :key="index">{{ councillor.name }}</li>
      </ul>
    </div>

    
    <h3 v-if="schoolDivisionWards.length">
      <a :href="trustee_url" target="_blank">{{ $t('school_divisions.' + schoolDivisionKey) }}</a>
    </h3>
    <h3 v-else>
      <a href="https://www.srsd.ca/governance/2022_school_trustee_election" target="_blank">{{ $t('school_divisions.' + schoolDivisionKey) }}</a>
    </h3>
    <div v-for="(ward, index) in schoolDivisionWards" :key="index">
      <h4>{{ $t('school_division_wards.ward' + ward.key) }}</h4>
      <div class="jump-list">
        <ul class="list-unstyled">
          <li v-for="(candidate, jndex) in ward.candidates" :key="jndex">{{ candidate.name }}</li>
        </ul>
      </div>
    </div>
   </div>
</template>

<script>
import axios from 'axios';

let sort_by_id_or_nomination_order = function(a,b) {
  if (a.nomination_order && b.nomination_order) {
    return (parseInt(a.nomination_order) < parseInt(b.nomination_order)) ? -1 : 1;
  } else {
    return (a.id < b.id) ? -1 : 1 
  }
}


export default {
  data() {
    return {
      election_year: '2022-01-01',
      candidates: [],
    }
  },
  mounted() {
    this.fetch_candidates(this.election_year);
  },

  props: ['nominated_period', 'addressDetails'],

  methods: {
    async fetch_candidates(election_year) {
      //random string to break the cache
      try {

        const random_string = '&_=' + Math.floor(Math.random()*10000000);
        const url = this.$CANDIDATES_API_URL + '?$where=election_date > "' + election_year + '"&$limit=100000000' + random_string;
        let results = await axios.get(url);
        if (results.data) {
          this.candidates = results.data;
        }
      } catch (e) {
        const backup_url = this.$VUE_APP_BACKUP_DATA;
        let results = await axios.get(backup_url);
        if (results && results.data) {
          this.candidates = results.data;
        }
      }
    }
  },

  computed: {
    filtered_candidates() {
      return this.candidates.filter(candidate => !this.nominated_period || candidate.candidate_status == "Nominated");
    },

    mayors() {
      return this.filtered_candidates.filter(candidate => candidate.type === 'Mayor').sort((a,b) => sort_by_id_or_nomination_order(a,b));
    },
    
    mayor_url() {
      return ((this.$LANG === 'en') ? '' : '/francais') + '/clerks/election/election-2022/Candidates/#Mayor';
    },

    councillor_url() {
      return ((this.$LANG === 'en') ? '' : '/francais') + '/clerks/election/election-2022/Candidates/#' + this.ward;
    },
    
    trustee_url() {
      return ((this.$LANG === 'en') ? '' : '/francais') + '/clerks/election/election-2022/Candidates/#trustee';
    },

    ward() {
      return (this.addressDetails && this.addressDetails.councilWard) ? this.addressDetails.councilWard.toLowerCase().replace(/[^a-z-]/gi,'') : '';
    },
    
    cleanWard() {
      return (this.addressDetails && this.addressDetails.councilWard) ? this.addressDetails.councilWard.replace(/ - /gi,'-') : '';
    },
    
    schoolDivision() {
      return (this.addressDetails && this.addressDetails.schoolDivision && this.addressDetails.schoolDivision === 'St James-Assiniboia') ? 
        'St. James - Assiniboia' :
        (this.addressDetails && this.addressDetails.schoolDivision) ? this.addressDetails.schoolDivision : '';
    },
    
    schoolDivisionWard() {
      return (this.addressDetails && this.addressDetails.schoolDivisionWard) ? this.addressDetails.schoolDivisionWard : '';
    },
    
    schoolDivisionKey() {
      return this.schoolDivision.toLowerCase().replace(/[^a-z-]/gi,'');
    },

    councillors() {
      if (this.addressDetails && this.addressDetails.councilWard) {
        return this.filtered_candidates.filter(candidate => candidate.type === 'Councillor' && candidate.ward === this.cleanWard).sort((a,b) => sort_by_id_or_nomination_order(a,b));
      }
      return [];
    },
    
    schoolDivisionWards() {
      let ordered_wards = Object.keys(this.trustees);
      ordered_wards.sort((a,b) => (a < b) ? -1 : 1);
      return ordered_wards.map(key => {
        return { key: key, candidates: this.trustees[key] }
      })
      /*
      console.log(ordered_wards);
      */
     },
    
    trustees() {
      if (this.schoolDivision) {
        let trustees = this.filtered_candidates.filter(candidate => candidate.type === "School Trustee" && candidate.school_division === this.schoolDivision && candidate.school_division_ward == this.schoolDivisionWard).sort((a,b) => sort_by_id_or_nomination_order(a,b));
        let school_division_wards = {};
        trustees.forEach(trustee => {
          if (school_division_wards[trustee.school_division_ward]) {
            school_division_wards[trustee.school_division_ward].push(trustee);
          } else {
            school_division_wards[trustee.school_division_ward] = [trustee];
          }
        })
        return school_division_wards;
      }
      return {};
    }

  }
}
</script>
